import React from 'react';
import './HomeHero.css';

const HomeHero = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-line">Discover artists</span><br />
            <span className="title-line">Support music</span>
          </h1>
          <p className="hero-subtitle">The stage you discover today creates the star of tomorrow.</p>
          {/* <p className="hero-description">
            Anta cursus risus ullamcorper odio facilisis. Purus semper nisi malesuada porttitor sed commodo tortor.
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default HomeHero; 